export default "__VITE_ASSET__DRnXyXQa__"